import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { SidebarTaskGroupUi } from 'src/app/routes/routes-with-sidebar/shared/components/sidebar/model/sidebar.model';

@Component({
  selector: 'ri-resolution-ui-manual-portal-group-template',
  templateUrl: './manual-portal-group-template.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ManualPortalGroupTemplateComponent {
  readonly group = input.required<SidebarTaskGroupUi>();
}
